<template>
  <div id="app">
    <template v-if="$store.state[$route.params.slug]">
      <Header />
      <router-view/>
      <Footer />
    </template>
    <template v-else>
      <WrongRoute />
    </template>
  </div>
</template>

<script>
export default {
  components: {
    Header: () => import('@/components/Header.vue'),
    Footer: () => import('@/components/Footer.vue'),
    WrongRoute: () => import('@/components/WrongRoute.vue'),
  },
}
</script>
